import withCotizacion from 'src/HOC/withCotizacion';
import { UrlImagenes } from 'src/parametros';
import React, { useState } from 'react';
import { Alert, Button, Image } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import ModalTransaccionesPendientes from './ModalTransaccionesPendientes';

const PorcentajeCompra = ({
  onClickGoBack,
  porcentaje,
  hiddeBackButton = false,
  cotizacion,
  history,
  finalizada,
  goBack,
  goNext,
}) => {
  const { push } = history;
  const location = useLocation();
  const defaultGoBack = () => goBack();
  const [show, setShow] = useState(
    cotizacion.transaccionesPendientesPTP &&
      cotizacion.transaccionesPendientesPTP.length > 0,
  );

  const goFinish = () => {
    push(`/newFinCompra/${cotizacion.idCotizacion}`);
  };
  const [modalShow, setModalShow] = React.useState(false);
  const showFinishButton = () => {
    const isPathFinish = '/newfincompra/'.includes(
      location.pathname.toLowerCase().split('/')[1],
    );

    if (isPathFinish) {
      return false;
    }

    return finalizada;
  };

  return (
    <React.Fragment>
      <div className="row justify-content-around">
        <div className="col-12 col-md-10 mt-3">
          <div className="row justify-content-around">
            <div className="col-2 text-left align-self-center">
              {goBack && (
                <button
                  className="btn btn-block text-right mt-3"
                  onClick={() => { onClickGoBack && onClickGoBack(); history.push(goBack);}}
                >
                  <i className="fa fa-arrow-left" />
                </button>
              )}
            </div>

            <div className="col-8 text-center">
              {cotizacion.aseguradora && cotizacion?.aseguradora?.img && (
                <Image
                  src={`${UrlImagenes}${cotizacion.aseguradora.img}`}
                  //src="https://i.blogs.es/a19bfc/testing/450_1000.jpg"
                  rounded
                  fluid
                  style={{ width: '80px' }}
                />
              )}
            </div>

            <div className="col-2 text-right  align-self-center">
              {goNext && (
                <button
                  className="btn btn-block text-right mt-3"
                  onClick={() => history.push(goNext)}
                >
                  <i className="fa fa-arrow-right" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="d-none">
        {!hiddeBackButton && (
          <button
            className="btn btn-block text-left mt-3"
            onClick={onClickGoBack || defaultGoBack}
            style={{ float: 'left' }}
          >
            <i className="fa fa-arrow-left" />
          </button>
        )}
        {showFinishButton() && (
          <button
            className="btn btn-block text-right mt-3"
            onClick={goFinish}
            style={{ float: 'right' }}
          >
            <i className="fa fa-arrow-right" />
          </button>
        )}
      </div>

      <div className="row justify-content-center mt-3">
        {show && (
          <div className="col-12 col-md-8">
            <Alert variant="warning" onClose={() => setShow(false)} dismissible>
              <p className="text-left">
                Estimado cliente, usted tiene cotizaciones pendientes de
                aprobación del pago.
              </p>

              <div className="text-center">
                <Button
                  variant="outline-info"
                  onClick={() => setModalShow(true)}
                >
                  Ver mas detalles
                </Button>
              </div>
            </Alert>
          </div>
        )}

        <div className="col-12 text-center mt-2">
          <p>{porcentaje}% Completado</p>
        </div>
        {cotizacion.producto && (
          <h4 className="font-weight-bold text-center">
            {cotizacion.producto.nombre}
          </h4>
        )}
      </div>
      <ModalTransaccionesPendientes
        show={modalShow}
        setModalShow={setModalShow}
      />
    </React.Fragment>
  );
};

export default withCotizacion(PorcentajeCompra);
